import { useLocation, Link } from "react-router-dom";
import { usePageMeta } from "../lib/seo";

export function NotFoundPage() {
  const location = useLocation();

  // Without this, an unrecognized URL would keep whatever <title>/canonical/robots meta the
  // previously-rendered page last set (this component never ran usePageMeta of its own) — so a
  // broken/typo'd link could look, to a JS-executing crawler, like an indexable duplicate of
  // whatever page the visitor came from. noindex here is the client-side half of the fix; the
  // other half is the server actually answering unknown paths with a real 404 status instead of
  // sirv's SPA-fallback 200 (see server.mjs).
  usePageMeta({
    title: "Page not found",
    description: "The page you're looking for doesn't exist or may have moved.",
    path: location.pathname,
    index: false,
  });

  return (
    <div className="empty-state">
      <h1>Page not found</h1>
      <p>The page you&apos;re looking for doesn&apos;t exist or may have moved.</p>
      <Link to="/" className="btn btn-primary">
        Back to marketplace
      </Link>
    </div>
  );
}
